import { render, staticRenderFns } from "./SidebarBoxAuexTicker.vue?vue&type=template&id=683c24df&scoped=true&"
import script from "./SidebarBoxAuexTicker.vue?vue&type=script&lang=js&"
export * from "./SidebarBoxAuexTicker.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBoxAuexTicker.vue?vue&type=style&index=0&id=683c24df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683c24df",
  null
  
)

export default component.exports